import React from 'react'
import { TaskContributorsByTask } from './task-contributors'
import { MelddTasks } from '../task.types'

export const TaskContributorsTabs: React.FC<{
  task: MelddTasks
  isOwner: boolean
}> = ({ task }) => {
  return <TaskContributorsByTask fixedFilters={{ taskId: task.id }} />
}
